/**
 * HearBell — "Hear a bell" preview element for HomeScreen.
 * Triggers a single preview bell via the passed callback.
 * UI-INV-009: Local animation state is permitted.
 */
import { useState, useRef } from "react";
import styles from "./HearBell.module.css";
import { TIMING } from "../constants";

type Props = { onPlay: () => void };

export function HearBell({ onPlay }: Props) {
  const [ringing, setRinging] = useState(false);
  const [tapped, setTapped] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handlePlay = () => {
    if (ringing) return;
    onPlay();
    setRinging(true);
    setTapped(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setRinging(false), TIMING.BELL_RING_DURATION_MS);
  };

  return (
    <>
      <button
        className={`${styles.hearBell} ${ringing ? styles.ringing : ""}`}
        onClick={handlePlay}
        disabled={ringing}
        aria-label="Hear a bell"
      >
        <span className={styles.circle} />
        <span className={styles.label}>
          {ringing ? "ringing…" : "Hear a bell"}
        </span>
      </button>
      {tapped && !ringing && (
        <p className={styles.muteHint}>No sound? Unmute your phone.</p>
      )}
    </>
  );
}
